import { render, staticRenderFns } from "./partnerList.vue?vue&type=template&id=5278025c&scoped=true&"
import script from "./partnerList.vue?vue&type=script&lang=ts&"
export * from "./partnerList.vue?vue&type=script&lang=ts&"
import style0 from "./partnerList.vue?vue&type=style&index=0&id=5278025c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5278025c",
  null
  
)

export default component.exports